export const MAX_DOCUMENTS_PER_SEARCH = 500;
export const MAX_CHUNKS_PER_DOCUMENT = 5;
